import utils from '../utils/utils.js'
import Flow from 'nflow'

var requestManager  = function(){};

//Queue to store the ensure-auth request events
var requestQueue=[];
var awaitingResponse=false;
var auth;

requestManager.init = (authNode)=>{
    auth=authNode;
}

requestManager.ensureAuthenticated = (event)=>{
	processEnsureAuthenticated(event);
}

//Queue the ensure-authenticated requested and respond on receiving the callback
function processEnsureAuthenticated(event){
	requestQueue.push(event);
	if(!awaitingResponse){
		utils.ensureAuthenticated(auth.data().validateSessionUrl, auth.data().relayState, userDetails => {
   	 		auth.data().userDetails = userDetails;
   	 		handleUserDetails(auth);
  		})
    awaitingResponse=true;
	}
}

function handleUserDetails(auth){
  awaitingResponse=false;
	while(requestQueue.length>0){
		let event = requestQueue.shift();
    event.parent().create('auth-success').direction(Flow.direction.DOWNSTREAM).emit();
	}
}

requestManager.logout = (event)=>{
  const auth = event.target;
  utils.logoutAndRedirect(auth.data().logoutUrl);
}

requestManager.sendUserDetails = (event)=> {
  event.parent().create('user-details-update', auth.data().userDetails).direction(Flow.direction.DOWNSTREAM).emit();
}

export default requestManager;


/** WEBPACK FOOTER **
 ** ./components/request-manager/request-manager.js
 **/